import React from "react";
import { object } from "prop-types";

import ComponentContainer from "../../layouts/component-container";
import NewsWithNoImage from "../../molecules/NewsWithNoImage";
import NewsHeadline from "../../atoms/NewsHeadline";
import Organism1 from "./Organism1";

import { useDevice } from "../../utils/react-utils";

import "./oneSpecialStory3Related.m.css";

const OneSpecialStory3Related = ({ collection }) => {
  if (!collection?.items?.length) return null;

  const { mobile } = useDevice();

  const {
    items,
    "associated-metadata": { theme = "red" },
  } = collection;

  const stories = items.reduce((accumulator, item) => {
    if (item.type === "story") {
      accumulator.push(item.story);
    }
    return accumulator;
  }, []);

  if (!stories.length) return null;

  const [firstStory, ...remainingStories] = stories;

  return (
    <ComponentContainer collection={collection} styleName="base" className={theme} border={false} disableArrow={true}>
      <div styleName="wrapper">
        <div styleName="grid-item">
          <NewsWithNoImage story={firstStory} iconEnd={false} showExcerpt={!mobile} />
          <div styleName="remaining-stories">
            {remainingStories.map((story, i) => (
              <NewsHeadline key={i} story={story} showSponsor={false} />
            ))}
          </div>
        </div>
        <Organism1 story={firstStory} />
      </div>
    </ComponentContainer>
  );
};

OneSpecialStory3Related.propTypes = {
  collection: object.isRequired,
};

OneSpecialStory3Related.storyLimit = 4;

export default OneSpecialStory3Related;
